export default [

     {
          path: '/major-season',
          name: 'MajorSeason',
          component: () => import("@/views/Page/MajorSeason/MajorSeason.vue"),
           meta: {
               title: '#Default# | MajorSeason',
          },
     }
];